import React from 'react'
import "../../routes/Home.css"
import image1 from "../../assets/image1.png"
const Section2 = () => {
  return (
    <div className="section2">
          <img className="image1"src={image1}/>
        </div>
  )
}

export default Section2